export const actions = {
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    CLOSE_AND_CALLBACK: 'CLOSE_AND_CALLBACK',
}